import classNames from "components/ui/classNames";
import * as React from "react";
import TextareaAutosize from "react-autosize-textarea";

interface CommentInputTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  disabled?: boolean;
}

export default function CommentInputTextArea({ className, ...props }: CommentInputTextAreaProps) {
  return (
    <TextareaAutosize
      {...props}
      className={classNames(
        "box-border flex w-full resize-none appearance-none rounded-xl",
        "p-3 font-aeonik text-sm font-normal tracking-wider",
        "border border-slate-300",
        "placeholder:text-slate-400",
        "ring-inset focus:shadow-md focus:ring-2 focus-visible:ring-slate-500",
        "disabled:bg-slate-100 disabled:text-slate-600",
        "focus:border-transparent dark:border-slate-950 dark:bg-slate-800 dark:text-slate-300 dark:placeholder:text-slate-400",
        "dark:focus-visible:ring-slate-500 dark:focus-visible:placeholder:text-slate-400",
        "dark:text-white dark:focus:ring-blue-400",
        className,
      )}
    />
  );
}
